import { render, staticRenderFns } from "./MyCollectionViewer.vue?vue&type=template&id=15b4428c&scoped=true&"
import script from "./MyCollectionViewer.vue?vue&type=script&lang=js&"
export * from "./MyCollectionViewer.vue?vue&type=script&lang=js&"
import style0 from "./MyCollectionViewer.vue?vue&type=style&index=0&id=15b4428c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4428c",
  null
  
)

export default component.exports